import type { ComponentEditorMetaDataDefinition } from '../types';

import { documentTypeUtils } from '@wix/santa-editor-utils';

const metaData: ComponentEditorMetaDataDefinition = {
  pinnable: false,
  skipInQuickEditPanel: true,
  allowConnectToDB: true,
  supportedInCurrentDocument: () =>
    !documentTypeUtils.isCurrentDocumentTypeIsFluidDocument(),
};

export default metaData;
